import { Calendar } from "lucide-react";
import GrayCard from "./GrayCard";
import { formatDate } from "@/lib/utils";

interface ExamDateCardProps {
  date: Date;
}

const ExamDateCard = ({ date }: ExamDateCardProps) => (
  <GrayCard>
    <Calendar className="w-4 h-4 text-gray-500" />
    Date de l'examen : {formatDate(date)}
  </GrayCard>
);

export default ExamDateCard;
